import { Banner } from '@components';
import type { FC } from 'react';

import type Enums from '@core/types/api/Enums';
import { editLockHolderMessage } from '@core/utils/editLock';
import { hasStringValue } from '@core/utils/equality';

type Props = {
  entity: Enums.EditLockEntity;
  editorName: string;
};

export const EditLockNotice: FC<Props> = ({ entity, editorName }) => (
  <Banner severity='warning' title={editLockHolderMessage(entity, editorName)}>
    {`You're viewing the current version in view-only mode. Fields stay disabled until ${hasStringValue(editorName) ? editorName : 'the other editor'} saves or closes the form.`}
  </Banner>
);
